import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import '@ant-design/compatible/assets/index.css';
import {
  Col,
  Row,
  Form,
  DatePicker,
  Input,
  Radio,
  Card,
  InputNumber,
  Checkbox,
  Spin,
} from 'antd';
import Text from 'antd/lib/typography/Text';
import UCheckBox from 'components/Checkbox';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import {
  EntityAdditionalAttributeRequest,
  getThirdPartyById,
  ViewEntityAddAttributeResponse,
} from 'services/thirdParty';
import ParListSelect from 'components/ParListSelect';
//import Form from 'antd/lib/form/Form';
import { shouldUpdateCompare, toDatePickerDate } from 'utils/utils2';
import ThirdPartyInput from 'components/ThirdPartyInput';
import InputRate from 'components/InputRate';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import { isBoolean, isInteger, isNil, isNumber } from 'lodash';
import moment from 'moment';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';

export type TabTPGeneralDataProps = {
  objectid: number;
  object: string;
  form: FormInstance;
  gettptype: (tp: any) => void;
  setSuccessful: any;
  setadditionalAttributeList: any;
};

const TabTPGeneralData = ({
  objectid,
  object,
  form,
  gettptype,
  setSuccessful,
  setadditionalAttributeList,
}: TabTPGeneralDataProps) => {
  const [error, setError] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    address: {},
    generalData: {},
  });

  const [tptype, settptype] = useState<string>('');

  const { data, isFetching } = useQuery(
    ['getThirdPartyById', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: true }
  );

  const { data: attlist } = useAttributeContextFramework(
    'THIRDPARTY',
    'THIRDPARTY',
    tptype,
    '',
    '',
    '',
    ''
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (data) {
      const { generalData } = data;
      settptype(generalData?.tptype);
      form?.setFieldsValue({
        tpreference: generalData.tpreference,
        tpactivity: generalData.tpactivity,
        tpmarketingname: generalData.tpmarketingname,
        tpflagvatexemption: generalData.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          generalData.tpvatexemtionenddate
        ),
        tpcapital: generalData.tpcapital,
        tpcapitalholding: generalData.tpcapitalholding,
        tpkycstatus: generalData.tpkycstatus,
        tpbirthcity: generalData.tpbirthcity,
        tpbirthcountry: generalData.tpbirthcountry,
        tpbirthdate: toDatePickerDate(generalData.tpbirthdate),
        tpbranchid: generalData.tpbranchid,
        tpcompanycreationdate: toDatePickerDate(
          generalData.tpcompanycreationdate
        ),
        tpfiscalcity: generalData.tpfiscalcity,
        tpfiscalid: generalData.tpfiscalid,
        tpgender: generalData.tpgender,
        tpid: generalData.tpid,
        tpidentitycardid: generalData.tpidentitycardid,
        tpidentitycardtype: generalData.tpidentitycardtype,
        tplegalform: generalData.tplegalform,
        tpmaidenname: generalData.tpmaidenname,
        tpmanagername: generalData.tpmanagername,
        tpmanagerposition: generalData.tpmanagerposition,
        tpmaritalstatus: generalData.tpmaritalstatus,
        tpmiddlename: generalData.tpmiddlename,
        tpname: generalData.tpname,
        tpnbofchildren: generalData.tpnbofchildren,
        tpprofession: generalData.tpprofession,
        tpsalutationcode: generalData.tpsalutationcode,
        tpsurname: generalData.tpsurname,
        tptaxid: generalData.tptaxid,
        tptype: generalData.tptype,
        tpworkingctdate: toDatePickerDate(generalData.tpworkingctdate),
        tpworkingcttype: generalData.tpworkingcttype,
        tpstatuslabelgeneraldata:
          generalData?.tpstatuslabel +
          ' (' +
          generalData?.tpstatusdate?.substring(0, 10) +
          ')',

        tpparentcompanyid: {
          tpid: generalData.tpparentcompanyid,
          tpname: generalData.tpparentcompanyidname,
          tpreference: generalData.tpparentcompanyidreference,
        },
        lancode: generalData?.lancode,
        countcode: generalData?.countcode,
        tptradingid: generalData?.tptradingid,
        tpcompanyid: generalData?.tpcompanyid,
        tpflagresident: generalData?.tpflagresident,
        tpidentitycardcountry: generalData?.tpidentitycardcountry,
        tpactivitysector: generalData?.tpactivitysector,
        tpcompanysize: generalData?.tpcompanysize,
        tpcategory: generalData?.tpcategory,
        tprevenue: generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          generalData?.tprevenuereferenceyear
        ),
        tpidentitycardexpirationdate: toDatePickerDate(
          generalData?.tpidentitycardexpirationdate
        ),
      });

      if (!isNil(data?.entityAddAttributList)) {
        let test = {};

        data?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              if (moment(att.attstringvalue, false).isValid()) {
                value = moment(att.attstringvalue, false);
              } else {
                value = null;
              }
            }
            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldsValue({ entityAddAttributList: test });
      }

      setState((prev: any) => ({
        ...prev,
        generalData: data,
        form,
        tpparentcompanyid: prev?.parentCompany?.tpid,
      }));
    }
  }, [data, form, objectid]);

  useEffect(() => {
    let entityAddAttribut = form.getFieldValue('entityAddAttributList');
    let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

    if (entityAddAttribut !== undefined) {
      Object.keys(entityAddAttribut).forEach(function (key, index) {
        let attnumericvalue: number = 0;
        let atttextvalue: string = '';
        let attbooleanvalue = null;
        let attstringvalue: string = '';
        if (isBoolean(entityAddAttribut[key])) {
          attbooleanvalue = Boolean(entityAddAttribut[key]);
        } else if (isNumber(entityAddAttribut[key])) {
          attnumericvalue = Number(entityAddAttribut[key]);
        } else if (String(entityAddAttribut[key])?.length < 100) {
          attstringvalue = entityAddAttribut[key];
          //atttextvalue = entityAddAttribut[key];
        } else {
          atttextvalue = entityAddAttribut[key];
        }

        let attdatatype = attlist?.find(
          (attribute: any) => key === attribute.attcode
        );

        let entityAddAttributData: EntityAdditionalAttributeRequest = {
          attbooleanvalue: attbooleanvalue ?? false,
          attcode: key,
          attnumericvalue: attnumericvalue,
          attstringvalue: attstringvalue,
          atttextvalue: atttextvalue,
          entity: '',
          entityid: 0,
          id: 0,
        };

        entityAddAttributList.push(entityAddAttributData);
      });
    }
    setadditionalAttributeList(entityAddAttributList ?? []);
  }, [form.getFieldValue('entityAddAttributList')]);

  return (
    <DF.Provider
      pagcode="TabTPGeneralData"
      additionalAttribute={{
        entity: 'THIRDPARTY',
        entitytype: tptype,
        object: 'THIRDPARTY',
      }}
      entity={object}
      entityid={objectid}
    >
      <Spin spinning={isFetching}>
        <Form.Item
          shouldUpdate={shouldUpdateCompare('tptype')}
          noStyle
          labelCol={{ span: 24 }}
        >
          {({ getFieldValue }) => {
            return getFieldValue('tptype') === 'PART' ? (
              <Card>
                <Row gutter={16}>
                  <FormInput col xs={4} name="tpreference">
                    <Value />
                  </FormInput>

                  <Form.Item shouldUpdate={() => true} noStyle>
                    <FormInput col xs={4} name="tptype">
                      <Text>Individual</Text>
                    </FormInput>
                  </Form.Item>
                  <FormInput
                    col
                    xs={8}
                    name="tpstatuslabelgeneraldata"
                    comcode="overallStatus"
                  >
                    <Value />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <UtinaCard
                    level={5}
                    comcode="ThirdPartyInfo"
                    style={{ color: '#000' }}
                    lg={10}
                    additionalAttribute
                  >
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpgender">
                        <Radio.Group>
                          <Radio value="M">Male</Radio>
                          <Radio value="F">Female</Radio>
                        </Radio.Group>
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpsalutationcode">
                        <ParListSelect parcode="TPSALUT" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item name="tpname" noStyle>
                      <FormInput
                        col
                        xs={12}
                        name="tpname"
                        labelCol={{ span: 24 }}
                      >
                        <Input
                          disabled={Number(objectid) >= 0 ? true : false}
                        />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        name="tpsurname"
                        labelCol={{ span: 24 }}
                      >
                        <Input
                          disabled={Number(objectid) >= 0 ? true : false}
                        ></Input>
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpbirthdate"
                        labelCol={{ span: 24 }}
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpbirthcountry"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect parcode="TPBIRTHPAY" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpbirthcity"
                        labelCol={{ span: 24 }}
                      >
                        <Input />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardtype"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect
                          parcode="CARDTYPE"
                          onChange={(e) => {
                            form.setFieldsValue({ tpidentitycardid: '' });
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardid"
                        labelCol={{ span: 24 }}
                      />
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardcountry"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect parcode="TPIDENTCNT" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardexpirationdate"
                        labelCol={{ span: 24 }}
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <FormInput
                      col
                      xs={12}
                      name="tpflagresident"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </FormInput>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="OthersInfo"
                    style={{ color: '#000' }}
                    lg={8}
                    additionalAttribute
                  >
                    <FormInput
                      col
                      xs={12}
                      lg={12}
                      name="lancode"
                      labelCol={{ span: 24 }}
                    >
                      <ParListSelect allowClear parcode="LANCODE" />
                    </FormInput>
                    <FormInput
                      col
                      xs={12}
                      lg={12}
                      name="countcode"
                      labelCol={{ span: 24 }}
                    >
                      <ParListSelect
                        allowClear
                        parcode="COUNTRY"
                        onChange={(e) => {
                          form.setFieldsValue({ tpfiscalcity: '' });
                        }}
                      />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpmaritalstatus"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect allowClear parcode="TPMARSTAT" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <>
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpnbofchildren"
                          labelCol={{ span: 24 }}
                        >
                          <InputNumber
                            formatter={(value) => {
                              if (
                                isNaN(Number(value)) ||
                                !isInteger(Number(value))
                              ) {
                                setError(true);
                                return ``;
                              } else {
                                setError(false);
                                return `${value}`;
                              }
                            }}
                            max={10}
                            min={0}
                            step={1}
                          />
                        </FormInput>
                        {error && (
                          <Col>
                            <p
                              role="alert"
                              style={{
                                color: 'rgb(255, 0, 0)',
                                paddingTop: '15%',
                              }}
                            >
                              Please make sure you've entered a <em>number</em>
                            </p>
                          </Col>
                        )}
                      </>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpactivitysector"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect
                          parcode="TPSECACTIV"
                          onChange={(e) => {
                            form.setFieldsValue({ tpactivity: '' });
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'tpactivitysector',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpactivity"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect
                            parcode="TPACTIVITY"
                            parvalueparent={getFieldValue('tpactivitysector')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpcategory"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect parcode="TPCATEGORY" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpprofession"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect parcode="PROFESSION" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpworkingcttype"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect parcode="WORKCTTYPE" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpworkingctdate"
                        labelCol={{ span: 24 }}
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="FiscalInfo"
                    style={{ color: '#000' }}
                    lg={4}
                    additionalAttribute
                  >
                    <FormInput
                      col
                      xs={24}
                      name="tpfiscalid"
                      labelCol={{ span: 24 }}
                    />
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'countcode',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput col xs={24} name="tpfiscalcity">
                          <ParListSelect
                            parcode="TRIBUNAL"
                            parvalueparent={getFieldValue('countcode')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                    <FormInput
                      col
                      xs={24}
                      name="tptaxid"
                      labelCol={{ span: 24 }}
                    />

                    <FormInput
                      col
                      xs={24}
                      name="tpflagvatexemption"
                      valuePropName="checked"
                      noStyle
                    >
                      <UCheckBox comcode="tpflagvatexemption" />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpflagvatexemption')}
                    >
                      {({ getFieldValue }) => {
                        return getFieldValue('tpflagvatexemption') ? (
                          <FormInput
                            name="tpvatexemtionenddate"
                            labelCol={{ span: 24 }}
                          >
                            <DatePicker />
                          </FormInput>
                        ) : (
                          ''
                        );
                      }}
                    </Form.Item>
                    <FormInput
                      col
                      xs={24}
                      name="tptradingid"
                      labelCol={{ span: 24 }}
                    >
                      <InputNumber min={0} />
                    </FormInput>
                    <FormInput
                      col
                      xs={24}
                      name="tpcompanyid"
                      labelCol={{ span: 24 }}
                    >
                      <InputNumber min={0} />
                    </FormInput>
                  </UtinaCard>
                </Row>
              </Card>
            ) : (
              getFieldValue('tptype') === 'PM' && (
                <Card>
                  <Row gutter={16}>
                    <FormInput col xs={4} name="tpreference">
                      <Value />
                    </FormInput>
                    <FormInput col xs={4} name="tptype">
                      <Text>Company</Text>
                    </FormInput>
                    <FormInput
                      col
                      xs={8}
                      name="tpstatuslabelgeneraldata"
                      comcode="overallStatus"
                    >
                      <Value />
                    </FormInput>
                  </Row>
                  <Row gutter={16}>
                    <UtinaCard
                      level={5}
                      comcode="ThirdPartyInfo"
                      style={{ color: '#000' }}
                      lg={10}
                      additionalAttribute
                    >
                      <Form.Item name="tpname" noStyle>
                        <FormInput
                          col
                          xs={12}
                          name="tpname"
                          labelCol={{ span: 24 }}
                        >
                          <Input
                            disabled={Number(objectid) >= 0 ? true : false}
                          ></Input>
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          name="tpmarketingname"
                          labelCol={{ span: 24 }}
                        />
                      </Form.Item>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpactivitysector"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect
                            parcode="TPSECACTIV"
                            onChange={(e) => {
                              form.setFieldsValue({ tpactivity: '' });
                            }}
                          />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare([
                          'tptype',
                          'tpactivitysector',
                        ])}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpactivity"
                            labelCol={{ span: 24 }}
                          >
                            <ParListSelect
                              parcode="TPACTIVITY"
                              parvalueparent={getFieldValue('tpactivitysector')}
                            />
                          </FormInput>
                        )}
                      </Form.Item>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tplegalform"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect parcode="LEGALFORM" />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpcompanycreationdate"
                          labelCol={{ span: 24 }}
                        >
                          <DatePicker />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpcapital"
                          labelCol={{ span: 24 }}
                        >
                          <InputNumber defaultValue={0} min={0} />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpcategory"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect parcode="TPCATEGORY" />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpcompanysize"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect parcode="TPCOMSIZE" />
                        </FormInput>
                      </Form.Item>
                      <FormInput
                        col
                        xs={12}
                        name="tpflagresident"
                        valuePropName="checked"
                      >
                        <Checkbox />
                      </FormInput>
                    </UtinaCard>

                    <UtinaCard
                      level={5}
                      comcode="OthersInfo"
                      lg={8}
                      additionalAttribute
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="lancode"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect allowClear parcode="LANCODE" />
                      </FormInput>
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="countcode"
                        labelCol={{ span: 24 }}
                      >
                        <ParListSelect
                          allowClear
                          parcode="COUNTRY"
                          onChange={(e) => {
                            form.setFieldsValue({ tpfiscalcity: '' });
                          }}
                        />
                      </FormInput>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpmanagername"
                          labelCol={{ span: 24 }}
                        />
                      </Form.Item>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpmanagerposition"
                          labelCol={{ span: 24 }}
                        >
                          <ParListSelect parcode="TPMANPOS" />
                        </FormInput>
                      </Form.Item>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={24}
                          md={24}
                          name="tpparentcompanyid"
                          labelCol={{ span: 24 }}
                        >
                          <ThirdPartyInput />
                        </FormInput>
                      </Form.Item>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tpcapitalholding"
                          labelCol={{ span: 24 }}
                        >
                          <InputRate defaultValue={0} min={0} />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tprevenue"
                          labelCol={{ span: 24 }}
                        >
                          <InputNumber defaultValue={0} min={0} />
                        </FormInput>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tptype')}
                        noStyle
                      >
                        <FormInput
                          col
                          xs={12}
                          lg={12}
                          name="tprevenuereferenceyear"
                          labelCol={{ span: 24 }}
                        >
                          <DatePicker />
                        </FormInput>
                      </Form.Item>
                    </UtinaCard>

                    <UtinaCard
                      level={5}
                      comcode="FiscalInfo"
                      style={{ color: '#000' }}
                      lg={4}
                      additionalAttribute
                    >
                      <FormInput
                        col
                        xs={24}
                        name="tpfiscalid"
                        labelCol={{ span: 24 }}
                      />
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare([
                          'tptype',
                          'countcode',
                        ])}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <FormInput col xs={24} name="tpfiscalcity">
                            <ParListSelect
                              parcode="TRIBUNAL"
                              parvalueparent={getFieldValue('countcode')}
                            />
                          </FormInput>
                        )}
                      </Form.Item>
                      <FormInput
                        col
                        xs={24}
                        name="tptaxid"
                        labelCol={{ span: 24 }}
                      />

                      <FormInput
                        col
                        xs={24}
                        name="tpflagvatexemption"
                        valuePropName="checked"
                        noStyle
                      >
                        <UCheckBox comcode="tpflagvatexemption" />
                      </FormInput>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('tpflagvatexemption')}
                      >
                        {({ getFieldValue }) => {
                          return getFieldValue('tpflagvatexemption') ? (
                            <FormInput
                              name="tpvatexemtionenddate"
                              labelCol={{ span: 24 }}
                            >
                              <DatePicker />
                            </FormInput>
                          ) : (
                            ''
                          );
                        }}
                      </Form.Item>
                      <FormInput
                        col
                        xs={24}
                        name="tptradingid"
                        labelCol={{ span: 24 }}
                      >
                        <InputNumber min={0} />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        name="tpcompanyid"
                        labelCol={{ span: 24 }}
                      >
                        <InputNumber min={0} />
                      </FormInput>
                    </UtinaCard>
                  </Row>
                </Card>
              )
            );
          }}
        </Form.Item>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPGeneralData;
